/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  ReplyScheduleCalendarApiV1ReplyScheduleCalendarGetQueryResponse,
  ReplyScheduleCalendarApiV1ReplyScheduleCalendarGetQueryParams,
  ReplyScheduleCalendarApiV1ReplyScheduleCalendarGetHeaderParams,
  ReplyScheduleCalendarApiV1ReplyScheduleCalendarGet422,
} from '../../types/ReplyScheduleCalendarApiV1ReplyScheduleCalendarGet.ts'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const replyScheduleCalendarApiV1ReplyScheduleCalendarGetQueryKey = (params?: ReplyScheduleCalendarApiV1ReplyScheduleCalendarGetQueryParams) =>
  [{ url: '/api/v1/reply_schedule/calendar' }, ...(params ? [params] : [])] as const

export type ReplyScheduleCalendarApiV1ReplyScheduleCalendarGetQueryKey = ReturnType<typeof replyScheduleCalendarApiV1ReplyScheduleCalendarGetQueryKey>

/**
 * @summary Reply Schedule Calendar
 * {@link /api/v1/reply_schedule/calendar}
 */
export async function replyScheduleCalendarApiV1ReplyScheduleCalendarGet(
  params?: ReplyScheduleCalendarApiV1ReplyScheduleCalendarGetQueryParams,
  headers?: ReplyScheduleCalendarApiV1ReplyScheduleCalendarGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ReplyScheduleCalendarApiV1ReplyScheduleCalendarGetQueryResponse,
    ResponseErrorConfig<ReplyScheduleCalendarApiV1ReplyScheduleCalendarGet422>,
    unknown
  >({ method: 'GET', url: `/api/v1/reply_schedule/calendar`, params, ...requestConfig, headers: { ...headers, ...requestConfig.headers } })
  return res.data
}

export function replyScheduleCalendarApiV1ReplyScheduleCalendarGetQueryOptions(
  params?: ReplyScheduleCalendarApiV1ReplyScheduleCalendarGetQueryParams,
  headers?: ReplyScheduleCalendarApiV1ReplyScheduleCalendarGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = replyScheduleCalendarApiV1ReplyScheduleCalendarGetQueryKey(params)
  return queryOptions<
    ReplyScheduleCalendarApiV1ReplyScheduleCalendarGetQueryResponse,
    ResponseErrorConfig<ReplyScheduleCalendarApiV1ReplyScheduleCalendarGet422>,
    ReplyScheduleCalendarApiV1ReplyScheduleCalendarGetQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return replyScheduleCalendarApiV1ReplyScheduleCalendarGet(params, headers, config)
    },
  })
}

/**
 * @summary Reply Schedule Calendar
 * {@link /api/v1/reply_schedule/calendar}
 */
export function useReplyScheduleCalendarApiV1ReplyScheduleCalendarGet<
  TData = ReplyScheduleCalendarApiV1ReplyScheduleCalendarGetQueryResponse,
  TQueryData = ReplyScheduleCalendarApiV1ReplyScheduleCalendarGetQueryResponse,
  TQueryKey extends QueryKey = ReplyScheduleCalendarApiV1ReplyScheduleCalendarGetQueryKey,
>(
  params?: ReplyScheduleCalendarApiV1ReplyScheduleCalendarGetQueryParams,
  headers?: ReplyScheduleCalendarApiV1ReplyScheduleCalendarGetHeaderParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ReplyScheduleCalendarApiV1ReplyScheduleCalendarGetQueryResponse,
        ResponseErrorConfig<ReplyScheduleCalendarApiV1ReplyScheduleCalendarGet422>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? replyScheduleCalendarApiV1ReplyScheduleCalendarGetQueryKey(params)

  const query = useQuery(
    {
      ...replyScheduleCalendarApiV1ReplyScheduleCalendarGetQueryOptions(params, headers, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<ReplyScheduleCalendarApiV1ReplyScheduleCalendarGet422>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}